import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37daa536"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "newsArchive" }
const _hoisted_2 = { class: "layout gutter--md" }
const _hoisted_3 = { class: "searchcontrols row align--center justify--space-around" }
const _hoisted_4 = { class: "md2 flex mobile" }
const _hoisted_5 = {
  class: "md5 flex",
  style: {"display":"flex"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_7 = { class: "md3 flex xs12" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_10 = { class: "va-table va-table--clickable va-table--hoverable newsArchiveTable" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "center" }
const _hoisted_13 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_15 = { class: "mr-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_17 = { class: "selectPageSize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_it_divider = _resolveComponent("it-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_va_popover, {
            color: "primary",
            message: "Nulstil kolonner"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                class: "btn",
                color: "#b4003a",
                rounded: false,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_icon, {
                    class: "reset",
                    name: "autorenew"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_va_input, {
            class: "searchInput",
            modelValue: _ctx.postSearchInputValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postSearchInputValue) = $event)),
            label: "Søg",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.findPost()), ["enter"]))
          }, {
            prependInner: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "find_in_page" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_button, {
            size: "small",
            class: "btn ml-2",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.findPost()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" }),
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_va_select, {
            "ml-4": "",
            modelValue: _ctx.filterByYearValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterByYearValue) = $event)),
            label: "Vis indlæg for året?",
            options: _ctx.filterByYearOptions,
            bordered: "",
            style: {"width":"75%"}
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createVNode(_component_it_divider),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.columnSort('title')))
                }, "Title"),
                _createElementVNode("th", {
                  class: "sorting center",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.columnSort('udgivet')))
                }, "Udgivet")
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indlaegs, (indlaeg, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  onClick: ($event: any) => (_ctx.goToNews(indlaeg.indlaeg_slug))
                }, [
                  _createElementVNode("td", null, _toDisplayString(indlaeg.indlaeg_versionerings_id?.[_ctx.getIndexOfPostVersion(indlaeg?.indlaeg_version, indlaeg)]?.indlaeg_versionering_titel), 1),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("i", null, _toDisplayString((new Date(indlaeg.indlaeg_udgivet)).toLocaleDateString('da-DK')), 1)
                  ])
                ], 8, _hoisted_11))
              }), 128))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_va_button, {
        icon: "first_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.jumpToPage(0)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.turnToNewPage(-5)))
      }),
      _createVNode(_component_va_button, {
        icon: "chevron_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.turnToNewPage(-1)))
      }),
      _hoisted_14,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentPage) = $event)),
        onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.currentPage]
      ]),
      _createElementVNode("p", _hoisted_15, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1),
      _createVNode(_component_va_button, {
        icon: "chevron_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.turnToNewPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.turnToNewPage(5)))
      }),
      _createVNode(_component_va_button, {
        icon: "last_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
      }),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_va_select, {
          class: "mr-2",
          modelValue: _ctx.pageSizeValueString,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
          options: _ctx.pageSizeOptions,
          bordered: ""
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}